var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-titration',{attrs:{"variation":_vm.variation,"conc-naoh":_vm.concNaOH,"conc-hcl":_vm.concHCL,"conc-mgoh2":_vm.concMgOH2,"mass-mgoh2":_vm.massMgOH2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }